<emm-management-layout>
    <main class="layout-center-content content" layout-center-content>
        <mat-button-toggle
            [disabled]="cleared | async"
            [attr.data-testid]="'clear_cache_button'"
            matTooltip="Clear cache"
            (click)="clearCache()"
        >
            Clear Cache <img class="icon" src="assets/img/bulldozer.svg"/>
        </mat-button-toggle>

        @if (!isProd && isAdminOrSuperAdmin) {
            <mat-button-toggle
                [attr.data-testid]="'copy_database_button'"
                matTooltip="Copy data from the EMM prod database"
                (click)="handleCopyProdDataClicked()"
                [disabled]="dataCopied | async"
            >
                Copy Prod Data <img class="icon" src="assets/img/nametags.svg"/>
            </mat-button-toggle>
            <mat-button-toggle
                [attr.data-testid]="'copy_database_button'"
                matTooltip="Copy data from the EMM prod database"
                (click)="handleMoveEffectiveDateClicked()"
                [disabled]="dataCopied | async"
            >
                Move Effective Date <img class="icon" src="assets/img/scheduling.svg"/>
            </mat-button-toggle>
        }
    </main>
    @if (showMoveDates) {
        <emm-operations-right-header layout-right-header></emm-operations-right-header>
    }
    <div layout-right-content>
        @if (showMoveDates && !isLoadingChangeSets && !isMovingChangeSets) {
            @if ((changeSets$ | async).length === 0) {
                <div class="no-change-sets">
                    <p class="no-change-sets__text">No future changes found.</p>
                </div>
            } @else {
                <div class="move-dates-panel">
                    <p class="move-dates-panel__subtitle">Select the effective dates to move to today</p>
                    <table mat-table [dataSource]="changeSets$" class="move-dates-table mat-elevation-z2">
                        <ng-container matColumnDef="select">
                            <th mat-header-cell *matHeaderCellDef></th>
                            <td mat-cell *matCellDef="let row; let i = index">
                                <mat-checkbox
                                    [checked]="isDateSelected(i)"
                                    [disabled]="isDateLocked(i)"
                                    (change)="onDateCheckboxChange(i, $event.checked)">
                                </mat-checkbox>
                            </td>
                        </ng-container>

                        <ng-container matColumnDef="effectiveDate">
                            <th mat-header-cell *matHeaderCellDef>Future Effective Dates</th>
                            <td mat-cell *matCellDef="let row">{{ formatDateForDisplay(row.effectiveDate) }}</td>
                        </ng-container>

                        <ng-container matColumnDef="submenus">
                            <th mat-header-cell *matHeaderCellDef>Impacted Submenus</th>
                            <td mat-cell *matCellDef="let row">
                                @for (submenu of row.subMenuIds; track submenu) {
                                    <div>{{ submenu }}</div>
                                }
                            </td>
                        </ng-container>

                        <ng-container matColumnDef="consumers">
                            <th mat-header-cell *matHeaderCellDef>Consumers</th>
                            <td mat-cell *matCellDef="let row">
                                @for (consumer of row.consumers; track consumer) {
                                    <div>{{ consumer }}</div>
                                }
                            </td>
                        </ng-container>

                        <tr mat-header-row *matHeaderRowDef="moveDatesColumns"></tr>
                        <tr mat-row *matRowDef="let row; let i = index; columns: moveDatesColumns;"
                            [class.move-dates-row--selected]="isDateSelected(i)">
                        </tr>
                    </table>

                    <div class="move-dates-panel__footer">
                        <button mat-raised-button color="primary"
                                [disabled]="selectedDateIndex < 0"
                                (click)="moveDatesToToday()">
                            Move to Today
                        </button>
                    </div>
                </div>
            }
        } @else if (showMoveDates && isLoadingChangeSets && !isMovingChangeSets) {
            <div class="loading-container-center">
                <mat-spinner diameter="60"></mat-spinner>
                <p class="loading-text">Loading change sets...</p>
            </div>
        }
        @if (showMoveDates && isMovingChangeSets) {
            <div class="loading-container-center">
                <mat-spinner diameter="60"></mat-spinner>
                <p class="loading-text">This may take some time, please wait while we reschedule the changes...</p>
            </div>
        }
    </div>
</emm-management-layout>
